<script lang="ts">
	import { push } from 'svelte-spa-router';
	import { Toolbar, Breadcrumbs } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	import CuryIntegrationContent from '../components/Integrations/CuryIntegration/CuryIntegrationContent.svelte';
</script>

<Toolbar class="mb-m">
	<Breadcrumbs
		aria-label={$format('label_cury', { default: 'Cury' })}
		slot="breadcrumbs"
		links={[
			{ label: 'Integrations', onClick: () => push('/settings/integrations') },
			{ label: 'Cury' },
		]}
	/>
</Toolbar>

<CuryIntegrationContent bottomMargin />
